import * as React from "react";

import { Button } from "semantic-ui-react";

import { TaskModel } from "@teamprevent/common/task/taskActions/models";

import { Link } from "redux-little-router";

interface OwnProps {
    task: TaskModel;
    customerId: string;
}

export const ManagerFeedbackOnReportButton: React.FunctionComponent<OwnProps> = (props: OwnProps) => {
    if (!props.task.completed) {
        return null;
    }

    const { customer, employeeRecord, caseId, id } = props.task;
    return (
        <Link href={`/customers/${customer.id}/employeeRecords/${employeeRecord.id}/ohCases/${caseId}/${id}/managerFeedbackOnReport`}>
            <Button floated="right">View</Button>
        </Link>
    );
};
